import * as React from 'react'
import { generatePath, useHistory, useLocation } from 'react-router-dom'
import { AsyncButton, Button, useAlert } from 'uxp/components'
import { IDefaultUIProps } from '../..'
import TemplateSelector from './TemplateSelector'

import './Layout.scss'
import { hasValue } from '../../util'

interface ILayoutProps extends IDefaultUIProps {
    headerActions?: () => JSX.Element
    showSelector?: boolean,
    onCloseSelector?: () => void
    hasModified?: boolean
}

const Layout: React.FunctionComponent<ILayoutProps> = (props) => {
    const { uxpContext, headerActions, showSelector, onCloseSelector, hasModified } = props

    const location = useLocation()
    const history = useHistory()
    const alerts = useAlert()
    const basePath = '/Apps/UXP/designer/widgets'

    const [showTemplateSelector, setShowTemplateSelector] = React.useState(false)

    const currentPath = location.pathname
    const inDesigner = currentPath.includes(basePath + '/new') || currentPath.includes(basePath + '/edit')
    const canGoBack = (location.state as any)?.canGoBack || false
    const goBackPath = (location.state as any)?.goToPath || basePath


    React.useEffect(() => {
        setShowTemplateSelector(showSelector)
    }, [showSelector])

    async function confirmResetChanges() {
        return alerts.confirm({
            title: 'Are you sure?',
            content: 'You have unsaved changes and they will be lost if continue',
            confirmButtonTitle: 'Continue',
            cancelButtonTitle: 'Cancel'
        })
    }

    function onSelectNewTemplate(id: string, moduleId?: string) {
        if (hasModified) {
            confirmResetChanges()
                .then((res: boolean) => {
                    if (res) startEditing(id, moduleId)
                })
        }
        else startEditing(id, moduleId)
    }

    function startEditing(id: string, moduleId?: string) {
        setShowTemplateSelector(false)

        let params: any = { 'template': id }
        if (hasValue(moduleId)) {
            history.push({pathname: generatePath(basePath + '/new/:template', params), search:  `module=${moduleId}`})
            return
        }
        history.push(generatePath(basePath + '/new/:template', params))
    }


    function onGoHome() {
        if (hasModified) {
            confirmResetChanges()
                .then((res: boolean) => {
                    if (res) goHome()
                })
        }
        else goHome()
    }

    function goHome() {
        history.push(basePath, { canGoBack: inDesigner, goToPath: currentPath })
    }

    function goBack() {
        history.push(goBackPath)
    }

    return <div className="widget-designer-container">

        <div className="header">
            <div className="left">
                <div className="logo-container">
                    <div className="logo"></div>
                </div>

                <div className="nav">

                    {canGoBack ?
                        <Button
                            title='Go Back'
                            icon='fas arrow-right'
                            onClick={goBack}
                            className="nav-btn"
                        />
                        :
                        <Button
                            title='Widgets'
                            icon='fas home'
                            onClick={onGoHome}
                            className="nav-btn"
                        />
                    }

                    <Button
                        title='Select a template'
                        icon='fas clone'
                        onClick={() => { setShowTemplateSelector(true) }}
                        className="nav-btn"
                    />

                </div>
            </div>
            <div className="right">
                <div className="actions">
                    {headerActions && headerActions()}
                </div>
            </div>
        </div>

        <div className="body">
            {props.children}
        </div>

        <TemplateSelector
            show={showTemplateSelector}
            onClose={() => {
                setShowTemplateSelector(false)
                onCloseSelector && onCloseSelector()
            }}
            uxpContext={uxpContext}
            onSelectTemplate={onSelectNewTemplate}
        />
    </div>
}

export default Layout